<template>
  <div class="benchmark">benchmark here</div>
</template>

<script>
export default {
  name: "benchmark",
};
</script>
